interface ErrorModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  destructive?: boolean;
}

const ErrorModal = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onClose,
  destructive = false,
}: ErrorModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4" role="dialog" aria-modal="true" aria-labelledby="feedback-modal-title">
      <div className="w-full max-w-md rounded-lg border border-dark-700 bg-dark-900 p-6 shadow-2xl">
        <h2 id="feedback-modal-title" className="text-xl font-semibold text-dark-100">{title}</h2>
        <p className="mt-3 text-sm leading-6 text-dark-300">{message}</p>
        <div className="mt-6 flex justify-end gap-3">
          <button type="button" onClick={onClose} className="rounded-lg bg-dark-700 px-4 py-2 text-sm text-dark-100 hover:bg-dark-600">
            {cancelLabel}
          </button>
          <button type="button" onClick={onConfirm} className={`rounded-lg px-4 py-2 text-sm font-medium text-white ${destructive ? 'bg-red-600 hover:bg-red-700' : 'bg-purple-600 hover:bg-purple-700'}`}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
